import React from 'react';
import "./Hero.scss";
import { Search } from "../"

const Hero = () => {
    return (
        <div className="hero">
            <div className="hero__titles">
                <span className="hero__titles-2">Servicios para tu hogar</span>
                <span className="hero__titles-1">¿Qué necesitas?</span>
                <span className="hero__titles-3">Facil, rapido y seguro</span>
            </div>
            <Search />
        </div>
    )
}

export default Hero;
